import { ABOUT_TEXT } from '../constants/config';

export default function Header() {
  return (
    <header className="relative z-10 border-b border-white/10 backdrop-blur-md bg-black/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-5xl font-black bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
              {ABOUT_TEXT.name}
            </h1>
            <p className="text-gray-400 mt-2 text-lg">{ABOUT_TEXT.title}</p>
          </div>
        </div>
      </div>
    </header>
  );
}
